import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/gymklar';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-58" data-mp="e3dirvkbfkrm">
      <div className="mx-auto max-w-6xl" data-id="element-59" data-mp="9mg9750515e">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-60" data-mp="58z49v7m0e9k">
          <div className="lg:col-span-7" data-id="element-61" data-mp="574iyfsfek4y">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-62" data-mp="3mguja2sg8vy9">Forskellen med ENGELSK PARAT™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-63" data-mp="3rhi8cix4b2pu">
              Fra stresset søndag aften til <em className="text-red-700" data-id="element-64" data-mp="3diqv0yq2xl2r">tryg og forberedt.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-65" data-mp="3ihv7pzc7q0xu">
            Forestil dig at starte ugen med engelsktimerne allerede på plads. Du ved, hvad klassen skal
            lære – og du har årsplanen, lektionerne, kopiarkene i tre niveauer og
            facitlisten klar.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-66" data-mp="1f9tr9n3k1tww">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-67" data-mp="1t18ek64hwh9r" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-68" data-mp="10cb4gqaftqs3">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-69" data-mp="wapnotus8scm">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-70" data-mp="1ab0ho5re2n20">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-71" data-mp="1a8eaw8cbobku">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-72" data-mp="15dh314qs489j">Uden ENGELSK PARAT™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-73" data-mp="2lnt739wpizew">
              Kender du det?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-74" data-mp="2ors7al23obk3">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-75" data-mp="2srsy756dyf81">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-76" data-mp="2xt8igv0qohpd" />
                  <span data-id="element-77" data-mp="32pp8juri1653">
                    <span className="block font-semibold text-slate-900/80" data-id="element-78" data-mp="32oxlj8bywgqf">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-79" data-mp="2a00417fkynyq">
            <p className="text-sm font-semibold text-red-300" data-id="element-80" data-mp="2js5v8ey0d1cv">Med ENGELSK PARAT™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-81" data-mp="2jtz3fyo9rtmz">
              Planlæg mindre. Undervis mere.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-82" data-mp="1rb37ewwpnjdc">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-83" data-mp="1jrau4qve2wt9">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-84" data-mp="1eukda1brfx6s">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="19sbhkx7i6h0z" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-86" data-mp="10vkliksyb26e">
          Fokusér på eleverne – ikke på at lave alle lektionerne selv.
        </p>
      </div>
    </section>;
}